import { useCallback, useEffect, useState } from 'react';
import { dashboardService, type CategoriesResponse, type PendingDetail } from '../../../services/dashboard.service';
import { CATEGORY_MAP } from '../../../utils/constants';

type Pending = { category: string; sub_category: string | null };

// CATEGORY_MAP is now a fallback only: it keeps the dropdowns usable if the
// request fails. The server list is the real one.
const FALLBACK: CategoriesResponse = {
  categories: CATEGORY_MAP,
  pending: [],
  order: Object.keys(CATEGORY_MAP),
};

export const useCategories = () => {
  const [data, setData] = useState<CategoriesResponse>(FALLBACK);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setData(await dashboardService.getCategories());
    } catch {
      setData(FALLBACK);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { void refresh(); }, [refresh]);

  const isPending = useCallback(
    (category: string, sub?: string) =>
      data.pending.some((p: Pending) =>
        p.category === category && (sub ? p.sub_category === sub : p.sub_category === null)
      ),
    [data.pending]
  );

  const pendingDetail: PendingDetail[] = data.pending_detail || [];

  return {
    categoryMap: data.categories,
    order: data.order,
    pending: data.pending,
    pendingDetail,
    isPending,
    loading,
    refresh,
  };
};
